import { initI18next } from '@sas/nova-commons/locale/useTextLocalizer';
import { NovaWebpackBackend } from '@sas/nova-commons/locale/WebpackBackend';
import { NovaComponentsNpmWebpackBackend } from '@sas/nova-commons/locale/npmbackends/NovaComponentsNpmWebpackBackend';
import { SASDesignNpmWebpackBackend } from '@sas/nova-commons/locale/npmbackends/SASDesignNpmWebpackBackend';
import { VAReactCoreEuaWebpackBackend } from '@sas-dvr/internal-va-react-core/i18n/VAReactCoreEuaWebpackBackend';

let initPromise: Promise<unknown> | undefined;

export function initNovaI18n() {
  if (initPromise) {
    return initPromise;
  }
  initPromise = initI18next([
    new NovaWebpackBackend(),
    new NovaComponentsNpmWebpackBackend(),
    new SASDesignNpmWebpackBackend(),
    new VAReactCoreEuaWebpackBackend(),
  ]);
  return initPromise;
}
